import React from "react";
import Proptypes from "prop-types";
import styled from "styled-components";
import {
  compose,
  space,
  color,
  layout,
  flexbox,
  typography,
  border,
} from "styled-system";

const StyledIcon = styled.i.attrs((props) => ({
  className: props.rounded
    ? `rounded", icon-${props.name}`
    : `icon-${props.name}`,
}))`
  ${compose(space, color, typography, layout, flexbox, border)}
  cursor: ${({ useCursorPointer }) =>
    useCursorPointer ? "pointer" : "inherit"};
`;

export const InvertedIcon = styled(StyledIcon).attrs({
  className: "invert-rounded",
})``;

const Icon = (props) => <StyledIcon {...props} />;

Icon.propTypes = {
  rounded: Proptypes.bool,
  name: Proptypes.string,
};

Icon.defaultProps = {
  rounded: false,
};

export default Icon;
